import { cn } from "@theprelude/core";
import { forwardRef, TextareaHTMLAttributes } from "react";

export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  function Input({ className, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        className={cn(
          "h-20 w-full resize-none rounded border border-stroke-input bg-surface-background px-3 py-2 text-sm focus:border-primary-foreground focus:outline-none",
          className,
        )}
        autoComplete="off"
        {...props}
      />
    );
  },
);
